import { Stack, Typography } from '@mui/material'
import OrderCard from './order-card/order-card.component'
import { Order } from '../../store/orders/orders.types'

interface OrderCardListProps {
  orders: Order[]
  selectedOrder: Order
  setIsOrderSelectedManually: (value: boolean) => void
  /** Message shown when there are no orders (e.g. "No archive order") */
  emptyMessage?: string
  onRepeatOrder?: (order: Order) => void
}

const OrderCardList = ({
  orders,
  selectedOrder,
  setIsOrderSelectedManually,
  emptyMessage,
  onRepeatOrder,
}: OrderCardListProps) => {
  return (
    <Stack spacing={1} mt={2}>
      {orders.length === 0 && emptyMessage ? (
        <Typography variant="body1" color="text.secondary" sx={{ py: 2, fontWeight: 700 }}>
          {emptyMessage}
        </Typography>
      ) : null}
      {orders.map((order: Order) => (
        <OrderCard
          key={order.orderId}
          order={order}
          selectedOrder={selectedOrder}
          setIsOrderSelectedManually={setIsOrderSelectedManually}
          onRepeatOrder={onRepeatOrder}
        />
      ))}
    </Stack>
  )
}

export default OrderCardList
